import { Injectable } from "@angular/core";
import {AbstractControl, AsyncValidator, ValidationErrors} from "@angular/forms";
import {Observable, of, BehaviorSubject} from "rxjs";
import { delay, map, retryWhen} from "rxjs/operators";
import { DELAY_BETWEEN_API_RETRIES, VALID_USERNAME_API_RETRIES } from "../constants";
import {Q2caliperService} from "../services/q2caliper.service";

@Injectable()
export class UsernameValidator implements AsyncValidator {
  private _useValidator: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  get useValidator(): Observable<boolean> {
    return this._useValidator.asObservable();
  }

  constructor(
    private q2caliperService : Q2caliperService,
  ) { }

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    if (control.value == null || control.value == "")
    {
      return of({required: true});
    }
    control.setErrors({ "required": true , emitEvent: false });

    let attempt = 0;
    return this.q2caliperService.isUsernameValid(control.value).pipe(
      retryWhen(errors => errors.pipe(
        delay(DELAY_BETWEEN_API_RETRIES),
        map(error => {
          if (attempt++ === VALID_USERNAME_API_RETRIES) {
            this._useValidator.next(false);
            throw error;
          }
          return error;
        }),
      )),
      map((response: boolean) => {
        control.setErrors({ "required": false , emitEvent: false });

        return !response ? { userExists: true } : null;
      })
    );
  }
}
